export * from "./software-rovo-pricing-page.template";
export { SoftwareRovoPricingPageTemplate as default } from "./software-rovo-pricing-page.template";
